import * as React from "react";
import { ContentSlideSidebar } from "./Sidebar";
import { useContentSlideStore } from "@/state/contentSlideStore";
import ContentSlide from "./contentSlide/ContentSlide";
import NewPrecedentSlide from "./newPrecedentSlide/NewPrecedentSlide";

const ContentSlideContainer: React.FC = () => {
  const { showSidebar } = useContentSlideStore();
  const precedentPanelMode = useContentSlideStore((s) => s.precedentPanelMode);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        gap: "1rem",
        minHeight: "100vh",
      }}
    >
      {showSidebar && <ContentSlideSidebar />}
      <div style={{ width: showSidebar ? "80%" : "100%", marginLeft: showSidebar ? "auto" : 0 }}>
        {precedentPanelMode === "createNew" ? <NewPrecedentSlide /> : <ContentSlide />}
      </div>
    </div>
  );
};

export default ContentSlideContainer;
